import { Serializers, SerializerValue } from "@megaron/serializers";

export const fulfillmentOrderFiltersSerializer = Serializers.object({
  page: Serializers.integer,
  fulfillmentStatus: Serializers.string.array().asJsonString(),
  financialStatus: Serializers.string.array().asJsonString(),
  deliveryMethod: Serializers.string.array().asJsonString(),
  isCancelled: Serializers.boolean,
}).partial();

export type FulfillmentOrderFilters = SerializerValue<typeof fulfillmentOrderFiltersSerializer>;
